<div class="panel">
	<h3 class="text-uppercase">{{ chartsTitle() }}</h3>
	@if (isChartsVisible()) {
	<div class="d-flex flex-row justify-content-around mt-5">
		<tsp-pie-chart [chartId]="activationChartId" [title]="activationChartTitle" [value]="activationValue()"
			[legend]="activationLegend" (selected)="select($event ? chartItems.ACTIVATED_NOT : chartItems.ACTIVATED)" />
		<tsp-pie-chart [chartId]="syncChartId" [title]="syncChartTitle" [value]="syncValue()" [legend]="syncLegend"
			(selected)="select($event ? chartItems.SYNC_NOT : chartItems.SYNC)" />
		<tsp-pie-chart [chartId]="scheduleChartId" [title]="scheduleChartTitle" [value]="scheduleValue()"
			[legend]="scheduleLegend" (selected)="select($event ? chartItems.SCHEDULE_NOT : chartItems.SCHEDULE)" />
	</div>
	}
</div>

@if (tableTitle(); as title) {
<h3>{{ title }}</h3>

<div class="row mb-5">
	<div class="col-12">
		<tsp-patient-table [patients]="items()" [hasPlanDetails]="false" [isFiltersCollapsed]="true" />
	</div>

	<div class="col-12 mt-5">
		<tsp-pagination [collectionSize]="collectionSize()" [(page)]="pageNumber" (pageChange)="updatePageNumber()"
			[(pageSize)]="pageSize" (pageSizeChange)="updatePageSize()" />
	</div>
</div>
}